import AnswerSlide, { AnswerSlideProps } from "./AnswerSlide";

export { AnswerSlideProps };
export default AnswerSlide;
